import { AfterViewInit, Directive, Input, OnDestroy } from '@angular/core';
import { ClientField } from '../models/client-field.model';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Field } from '@sb-tools/typescript/models/field.model';
import { FormCommonDataService } from '../services/form-common-data.service';
import { Subject } from 'rxjs';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';

@Directive({
    selector: '[appCheckCategoryValue]',
})
export class CheckCategoryValueDirective implements AfterViewInit, OnDestroy {
    @Input() formField: Field | ClientField;
    @Input() formType: FormType;

    private previousCategoryValue: number;
    private unsubscriber = new Subject<void>();

    constructor(private formCommonDataService: FormCommonDataService) {}

    ngAfterViewInit(): void {
        if (this.formField && this.formType === FormType.outlook) {
            this.formCommonDataService.formInitSubject.pipe(takeUntil(this.unsubscriber)).subscribe((form) => {
                this.initCategoryChangesListener(form);
            });
        }
    }

    private checkCategoryFieldValue(): void {
        const isCategoryValueChanged = this.formField.value !== this.previousCategoryValue;

        if (isCategoryValueChanged) {
            this.formCommonDataService.categoryUpdatedSubject.next(this.formField.value);
        }

        this.previousCategoryValue = this.formField.value;
    }

    private initCategoryChangesListener(form): void {
        form.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.checkCategoryFieldValue();
            });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
